import {Component, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import {
  FormBuilderService,
  NotificationService
} from '../../../services';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-validation-partial',
    templateUrl: './validation-partial.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [NgIf]
})
export class ValidationPartialComponent implements OnInit, OnDestroy {

  @Input() public formGroup: UntypedFormGroup;
  @Input() public fieldName: string;

  public showErrors = false;
  public subscription;

  constructor (private formBuilderService: FormBuilderService,
               private notificationService: NotificationService) {
  }

  ngOnInit() {
    this.subscription = this.formBuilderService.showValidationErrors.subscribe( (value) => {
      if (value) {
        this.formBuilderService.setFormGroupTouched(this.formGroup);
      } else {
        this.formGroup.markAsUntouched();
      }
      this.showErrors = value;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
